export function getBundleBadgeTooltipContent({ t, isInstalled, isCouponTypeBundle, appName, }) {
    if (!isInstalled && isCouponTypeBundle) {
        return t('solutionBox.badge.bundle-tooltip-voucher-not-installed', {
            appName,
        });
    }
    if (isInstalled && isCouponTypeBundle) {
        return t('solutionBox.badge.bundle-tooltip-installed-voucher', { appName });
    }
    return t('solutionBox.badge.bundle-tooltip', { appName });
}
//# sourceMappingURL=bundle-badge.utils.js.map